import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const actionsWorkflowsAppBuilder = DataRouterApplicationBuilder.create('actions-workflows')
